<a mat-icon-button matTooltip="Edit User" *ngIf="auth.canEdit(user)" matTooltipPosition="right" color="primary"
  (click)="goTo($event, 'edit')" [href]="editHref">
  <mat-icon>edit</mat-icon>
</a>
<a mat-icon-button matTooltip="View User" matTooltipPosition="right" color="accent" (click)="goTo($event, 'view')"
  [href]="viewHref">
  <mat-icon>visibility</mat-icon>
</a>